import { sizes } from "@hubrise/react-components"
import styled from "styled-components"

export const Page = styled.div`
  display: flex;
  height: 100%;
`

export const Side = styled.div`
  flex: 0 0 ${sizes.sidebarWidth};
  padding: 2rem 1rem 0 0;
`

export const Main = styled.div<{ topPadding: boolean }>`
  flex: 1 1 75rem;
  height: 100%;
  overflow-y: auto;
  padding: ${({ topPadding }) => (topPadding ? "2rem 0 0 1rem" : "0 0 0 1rem")};

  display: flex;
  align-items: start;
  gap: 0 2rem;
`
